import { MinusCircle, PlusCircle } from "lucide-react";
import ItemRow from "./ItemRow.jsx";

export default function OrderPanel({
  order,
  items,
  open,
  onToggleOpen,
  itemState,
  reasons,
  extraOptionsFor,
  labels,
  onToggleItem,
  onChangeItem,
  onSelectAll,
}) {
  // Buddy's order index carries no line items; they come from the per-order
  // endpoint when the panel is first opened.
  const lineItems = items?.lineItems ?? [];
  const returnable = lineItems.filter((i) => !i.returnState);
  const allSelected = returnable.length > 0 && returnable.every((i) => itemState[i.id]?.selected);

  return (
    <div className="bottom-buffer-s" id={`order${order.id}`}>
      <h4>
        <a
          id={`order_title${order.id}`}
          className={order.pastReturnDate ? "old" : undefined}
          onClick={onToggleOpen}
          // The old markup used a bare <a> with no href; keep it reachable.
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onToggleOpen();
            }
          }}
          aria-expanded={open}
          aria-controls={`order_content_${order.id}`}
        >
          {open ? (
            <MinusCircle className="opening-icon" size={16} aria-hidden="true" />
          ) : (
            <PlusCircle className="opening-icon" size={16} aria-hidden="true" />
          )}
          <span>
            {labels.initialOrderNo} {order.externalOrderNo}
          </span>
          <small>
            {labels.orderedOn}
            {order.orderedOnDisplay}
          </small>
        </a>
      </h4>

      <div id={`order_content_${order.id}`} style={{ display: open ? "block" : "none" }}>
        {items?.loading ? (
          <p>{labels.loading}</p>
        ) : items?.error ? (
          <p className="parsley-custom-error-message">{labels.loadError}</p>
        ) : lineItems.length === 0 ? (
          <p>{labels.noArticles}</p>
        ) : (
          <table className="table table-striped top-buffer-s">
            <thead>
              <tr>
                <th className="checkboxColumn">
                  {!order.pastReturnDate && (
                    <div className="gr-12 checkbox-wrapper gr-9@mobile prefix-1@mobile suffix-2@mobile">
                      <input
                        type="checkbox"
                        className="checkbox"
                        id={`select_all_${order.id}`}
                        checked={allSelected}
                        onChange={(e) => onSelectAll(e.target.checked)}
                      />
                      <label htmlFor={`select_all_${order.id}`}>
                        <span className="checkbox" />
                      </label>
                    </div>
                  )}
                </th>
                <th className="articleNameColumn">{labels.article}</th>
                <th className="priceColumn">{labels.price}</th>
                <th className="returnReasonColumn">{labels.returnReason}</th>
              </tr>
            </thead>
            <tbody>
              {lineItems.map((item, i) => (
                <ItemRow
                  key={item.id}
                  item={item}
                  index={i + 1}
                  orderId={order.id}
                  selected={Boolean(itemState[item.id]?.selected)}
                  state={itemState[item.id] ?? { reasonId: "", extraReason: "", detail: "" }}
                  reasons={reasons}
                  extraOptionsFor={extraOptionsFor}
                  labels={labels}
                  onToggle={(checked) => onToggleItem(item.id, checked)}
                  onChange={(patch) => onChangeItem(item.id, patch)}
                />
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
